import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress known react-pdf worker transport errors that occur when
// navigating away from a PDF while it's still rendering.
// These are harmless race conditions in pdfjs-dist.
window.addEventListener('error', (event) => {
  const msg = event.message || '';
  if (msg.includes('sendWithPromise') || msg.includes('transport is destroyed') || msg.includes('BodyStreamBuffer')) {
    event.preventDefault();
  }
});
window.addEventListener('unhandledrejection', (event) => {
  const msg = String(event.reason?.message || event.reason || '');
  if (msg.includes('sendWithPromise') || msg.includes('transport is destroyed') || msg.includes('BodyStreamBuffer')) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />,
);
